/**
 * メンバー写真を、画面に入ったタイミングで 1 人ずつ表示する。
 */
export function initMembers() {
  const list = document.querySelector('.js-members');
  if (!list || !('IntersectionObserver' in window)) {
    return;
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  list.classList.add('is-anim');

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting) {
        return;
      }

      list.classList.add('is-inview');
      observer.disconnect();
    },
    { threshold: 0.3 },
  );

  observer.observe(list);
}
